import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
  washbasinDimensions: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions',
    defaultMessage: 'Washbasin Dimensions',
  },
  typeOfInstallation: {
    id: 'ConfigurationDetail.WashBasinDimension.typeOfInstallation',
    defaultMessage: 'Type of installation',
  },
  angleOfNiche: {
    id: 'ConfigurationDetail.WashBasinDimension.angleOfNiche',
    defaultMessage: 'Angle of the Niche',
  },
  cornerDesign: {
    id: 'ConfigurationDetail.WashBasinDimension.cornerDesign',
    defaultMessage: 'Corner Design',
  },
  plateDimensions: {
    id: 'ConfigurationDetail.WashBasinDimension.plateDimensions',
    defaultMessage: 'Plate Dimensions',
  },
  distancesInMM: {
    id: 'ConfigurationDetail.WashBasinDimension.distancesInMM',
    defaultMessage: 'Position of the troughs',
  },
  apron: {
    id: 'ConfigurationDetail.ApronBacksplash.apron',
    defaultMessage: 'Apron',
  },
  surgeEdgeOrBackSplash: {
    id: 'ConfigurationDetail.ApronBacksplash.surgeEdgeOrBackSplash',
    defaultMessage: 'Surge edge / Back splash',
  },
  tapHole: {
    id: 'ConfigurationDetail.Recesses.tapHole',
    defaultMessage: 'Tap Hole',
  },
  soapDispenserHole: {
    id: 'ConfigurationDetail.Recesses.soapDispenserHole',
    defaultMessage: 'Soap Dispenser Hole',
  },
  paperTowelDispenserHole: {
    id: 'ConfigurationDetail.Recesses.paperTowelDispenserHole',
    defaultMessage: 'Cut-outs in the plate for ejector or paper towel dispense',
  },
  cosmeticTissueDispenser: {
    id: 'ConfigurationDetail.Recesses.cosmeticTissueDispenser',
    defaultMessage: 'Cosmetic tissue dispenser',
  },
  towelRail: {
    id: 'ConfigurationDetail.Recesses.towelRail',
    defaultMessage: 'Towel Rail',
  },
  color: {
    id: 'ConfigurationDetail.plateSurface.colour',
    defaultMessage: 'Colour',
  },
  colorBottomSide: {
    id: 'ConfigurationDetail.plateSurface.colorBottomSide',
    defaultMessage: 'Bottom Side',
  },
  apronTitle: {
    id: 'ConfigurationDetail.ApronBacksplash.apronTitle',
    defaultMessage: 'Apron / Backsplash',
  },
  drainTitle: {
    id: 'ConfigurationDetail.Drain.drainTitle',
    defaultMessage: 'Drain Accessories',
  },
  drainBtnDrainAccessories: {
    id: 'ConfigurationDetail.Drain.drainBtnDrainAccessories',
    defaultMessage: 'Drain Accessories',
  },
  drainBtnCompleteConfiguration: {
    id: 'ConfigurationDetail.Drain.drainBtnCompleteConfiguration',
    defaultMessage: 'Complete Configuration',
  },
  recessesBuiltInPartsTitle: {
    id: 'ConfigurationDetail.recessesBuiltInParts.recessesBuiltInPartsTitle',
    defaultMessage: 'Recesses / Built-in Parts',
  },
  colourTitle: {
    id: 'ConfigurationDetail.colour.colourTitle',
    defaultMessage: 'Colour',
  },
  troughsTitle: {
    id: 'ConfigurationDetail.troughs.troughsTitle',
    defaultMessage: 'Troughs',
  },
  note: {
    id: 'ConfigurationDetail.Drain.note',
    defaultMessage: 'Note:',
  },
  noteMessageNoOption: {
    id: 'ConfigurationDetail.Drain.noteMessage',
    defaultMessage: 'No options for selected trough.',
  },
  noteMessageVARIUSmedMZB: {
    id: 'ConfigurationDetail.Drain.noteVARIUSmedMZB',
    defaultMessage: 'Theft-proof drain cover with InoxPlus coating is included for Exos troughs.',
  },
  noteMessageExos: {
    id: 'ConfigurationDetail.Drain.noteExos',
    defaultMessage: 'Theft-proof drain cover with InoxPlus coating.',
  },
});

export default MESSAGES;